import BreadcrumbDropdown from './catalogue/BreadcrumbDropdown.vue';
import ProductViewer from './catalogue/ProductViewer.vue';
import AddToCart from './catalogue/AddToCart.vue';
import QuickCartDropdown from './QuickCartDropdown.vue';
import NewsList from './news/NewsList.vue';

import Menu from './acacia/Menu.vue';
import Header from './acacia/Header.vue';
import ReadMore from './acacia/ReadMore.vue';
import SearchResults from './acacia/search/SearchResults.vue';
import ProductResult from './acacia/search/result/ProductResult.vue';
import Frames from './acacia/tileblock/animation/Frames.vue';
import AcaField from './acacia/Field.vue';
import Form from './acacia/Form.vue';
import EmbedVideo from './acacia/EmbedVideo.vue';

import AccountMenu from './account/AccountMenu.vue';
import Confirm from './account/Confirm.vue';
import DateRange from './account/DateRange.vue';
import Downloader from './account/Downloader.vue';
import Field from './account/Field.vue';
import PaginatedContent from './account/PaginatedContent.vue';
import PostalCodeCity from "./account/PostalCodeCity.vue";
import Upload from "./account/Upload.vue";
import TermsModal from './account/TermsModal.vue';

import Cart from './account/cart/Cart.vue';
import CartItem from './account/cart/CartItem.vue';
import QuantitySelect from './account/cart/QuantitySelect.vue';
import OrderComments from './account/order/Comments.vue';
import OrganizationAddressesForm from './account/organization/AdressesForm.vue';
import ShowReferentEdit from './account/show/ReferentEdit.vue';
import Data from "./Data.vue";


export default {
    // Page inner components
    BreadcrumbDropdown,
    ProductViewer,
    AddToCart,
    QuickCartDropdown,

    NewsList,

    'v-data': Data,
    'ekip-account-menu': AccountMenu,
    'ekip-confirm': Confirm,
    'ekip-date-range': DateRange,
    'ekip-downloader': Downloader,
    'ekip-field': Field,
    'ekip-paginated-content': PaginatedContent,
    'ekip-postalcode-city': PostalCodeCity,
    'ekip-upload': Upload,
    'ekip-terms-modal': TermsModal,
    'ekip-cart': Cart,
    'ekip-cart-item': CartItem,
    'ekip-quantity-select': QuantitySelect,
    'ekip-order-comments': OrderComments,
    'ekip-organization-addresses-form': OrganizationAddressesForm,
    'ekip-show-referent-edit': ShowReferentEdit,

    'aca-menu': Menu,
    'aca-header': Header,
    'aca-search-results': SearchResults,
    'aca-read-more': ReadMore,
    'aca-product-result': ProductResult,
    'aca-frames': Frames,
    'aca-field': AcaField,
    'aca-form': Form,
    'aca-embed-video': EmbedVideo,

    'postal-code-city': PostalCodeCity,
}
